export default {
  edit: {
    attributes: [
      {attribute: "name", translated: true},
      {attribute: "identifier"}
    ]
  }
}
